// TravelMobile regions offered in the planner dropdown and the "All travel
// plans" tabs. The BE `Regions` / recommend `Location` values match these.
export const TRAVEL_REGIONS = [
    'Australia',
    'New Zealand',
    'Africa',
    'Pacific',
    'Asia',
    'Europe',
    'North America',
    'South America',
]

// Alphanumerics only, lowercased, so "North America", "north-america",
// "north_america" and "northamerica" all match.
const regionKey = (value) => String(value).toLowerCase().replace(/[^a-z0-9]/g, '')

const REGION_BY_KEY = TRAVEL_REGIONS.reduce((acc, region) => {
    acc[regionKey(region)] = region
    return acc
}, {})

// Deep-link leg `code` -> region name, or '' when it is not a region.
export const resolveRegion = (value) => {
    if (!value) return ''
    return REGION_BY_KEY[regionKey(String(value).trim())] || ''
}

export default resolveRegion
